<p-card header="">
    <div class="">
<div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
    <div class="flex align-items-center">

        <div class="flex align-items-center">
            <p-button label="New" class="p-button-outlined" icon="pi pi-plus-circle" size="small"
                (onClick)="createBOM()" pTooltip="Create Bill Of Material"></p-button>
        </div>

        <div class="flex align-items-center ml-3">
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder" class="p-inputtext-sm"
                    (keyup.enter)="searchBom()" style="height: 35px; font-size: 0.875rem; padding-left: 2rem;"
                    style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" autocomplete="one-time-code"/>
            </span>
            <p-button icon="pi pi-search" (onClick)="searchBom()" [raised]="true" [size]="'small'" severity="info"
                class="ml-2" [ngStyle]="{ height: '35px' }"></p-button>
        </div>
        
        <p-button *ngIf="selectedbillofmaterial?.length === 1" label="Edit" class="ml-2" icon="pi pi-pencil"
                size="small" severity="secondary" (onClick)="updateBOM()">
            </p-button>

            <p-button label="Delete" class="ml-2" icon="pi pi-trash" size="small" severity="danger"
                [style.visibility]="selectedbillofmaterial && selectedbillofmaterial.length > 0 ? 'visible' : 'hidden'"
                (onClick)="deleteBOM()">
            </p-button>
    </div>

    <h2 class="page-title-center">Bill Of Material List</h2>

    <div class="flex align-items-center" style="min-width: 50px;">
        <p-button icon="pi pi-refresh" size="small" (click)="refreshData()" [rounded]="true" severity="info"></p-button>
    </div>
</div>

        <p-table #dt1 [value]="result.bom" [scrollable]="true" scrollHeight="350px"
            styleClass="p-datatable-striped" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm"
            [paginator]="true" [rows]="10" [selectionPageOnly]="true" (onPage)="loadBom($event)"
            [(selection)]="selectedbillofmaterial" [globalFilterFields]="['productCode','warehouseCode','quantity','unitsOfMeasureCode','boMType','createdBy']"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10,15,20]">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 4rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>Product Name</th>
                    <th>{{unitLabel}}</th>
                    <th>Unit Of Measure</th>
                    <th>BOM Type</th>
                    <th>Created By</th>
                    <th>Print</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-billOfMaterials>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="billOfMaterials"></p-tableCheckbox>
                    </td>
                    <td class="text-blue-500 underline" style="cursor: pointer;" (click)="updateBOM(billOfMaterials.bomId)">{{billOfMaterials.productCode}}</td>
                    <td>{{billOfMaterials?.warehouseCode}}</td>
                    <td>{{billOfMaterials?.unitsOfMeasureCode}}</td>
                    <td>{{billOfMaterials?.boMType}}</td>
                    <td>{{billOfMaterials?.createdBy}}</td>
                    <td><span class="pi pi-print" style="color: rgb(0 35 255); cursor: pointer;"
                            (click)="showReport(billOfMaterials)"></span></td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="8">No Records found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-card>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
